import { createApi } from '@reduxjs/toolkit/query/react';
import { ACTIVE_SCHOOL_BANNERS_LIST, REPORTS_LISTING } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const schoolBannerApi = createApi({
    reducerPath: 'schoolBannerApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/school-banners",
    }),
    tagTypes: ["Profile"],
    endpoints: (builder) => ({
        getActiveSchoolBannersList: builder.query({
            query: () => ({
                method: "GET",
                url: `${ACTIVE_SCHOOL_BANNERS_LIST}`,
                // data: { page, limit, sort, search, status: status?.value, grade: grade?.value, discipline_id: discipline?.value }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ActiveSchoolBannersList"]
        }),
    }),
});

export const {
    useGetActiveSchoolBannersListQuery
} = schoolBannerApi;